import ServiceSettings from "../settings";

const BaseURL = ServiceSettings.apiURL;
const OneCustomerBaseURL = ServiceSettings.onecustomerURL;
export {BaseURL, OneCustomerBaseURL};
